var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import http, { Q, Api } from '@http';
import { intersectionBy } from 'lodash-es';
import { observable, action, runInAction, computed, reaction, toJS } from 'mobx';
import { ProCareSupportBundleType, BundleDataDirection, PredefinePriority, SessionKey } from '@common/enums/base';
import { isIH, isWPH } from '@common/utils';
import moment from 'moment';
import { caculateRecommendSchedules, caculateRecommendSchedulesForUrgent, generatorReactionHandler } from './util';
import { ScheduleResult } from '../entity/scheduleResult';
var AutoSchedule = /** @class */ (function () {
    function AutoSchedule(parent) {
        this.proCareSupportBundleType = ProCareSupportBundleType.Unsupported;
        this.proCareSupportBundleTypeOrigin = ProCareSupportBundleType.Unsupported;
        this.scheduleTimeBlocks = [];
        this.scheduleTimeBlocksPushOut = [];
        this.scheduleTimeBlocksPullIn = [];
        this.weather = [];
        this.scheduleLoading = false;
        this.procareBundlePushoutChecked = false;
        this.noAvailableChecked = false;
        this.parent = parent;
        this.init();
    }
    Object.defineProperty(AutoSchedule.prototype, "enableProcareBundle", {
        get: function () {
            var _this = this;
            return ((isIH() || isWPH()) &&
                this.proCareSupportBundleType !== ProCareSupportBundleType.Unsupported &&
                this.parent.isInHouseTechnician &&
                [PredefinePriority.NextAvailableService, PredefinePriority.RoutineStandardService].some(function (p) { return p === _this.parent.priority; }));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AutoSchedule.prototype, "enableProcareBundlePushout", {
        get: function () {
            return this.enableProcareBundle && this.parent.priority === PredefinePriority.RoutineStandardService;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AutoSchedule.prototype, "scheduleTimeBlocksByBundleType", {
        get: function () {
            if (!this.enableProcareBundle)
                return this.scheduleTimeBlocks;
            if (this.proCareSupportBundleType === ProCareSupportBundleType.PullIn)
                return this.scheduleTimeBlocksPullIn;
            if (this.proCareSupportBundleType === ProCareSupportBundleType.PushOut) {
                return this.procareBundlePushoutChecked ? this.scheduleTimeBlocksPushOut : this.scheduleTimeBlocks;
            }
            if (this.proCareSupportBundleType === ProCareSupportBundleType.PullInOrPushOut) {
                return this.procareBundlePushoutChecked ? this.scheduleTimeBlocksPushOut : this.scheduleTimeBlocksPullIn;
            }
            return this.scheduleTimeBlocks;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AutoSchedule.prototype, "showScheduleList", {
        get: function () {
            var scheduleList = this.scheduleTimeBlocksByBundleType;
            var recommends = this.parent.priority === PredefinePriority.NextAvailableService
                ? caculateRecommendSchedulesForUrgent(scheduleList)
                : caculateRecommendSchedules(scheduleList);
            recommends.forEach(function (recommend) {
                scheduleList.some(function (schdule) {
                    if (schdule.schedulestarttime === recommend.schedulestarttime) {
                        schdule.isRecommend = true;
                        return true;
                    }
                    return false;
                });
            });
            return scheduleList;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AutoSchedule.prototype, "sliceScheduleList", {
        get: function () {
            var _this = this;
            var list = this.showScheduleList;
            var result = __spreadArrays(list.filter(function (item) { return item.isRecommend; }), list.filter(function (item) { return !item.isRecommend; }).sort(function (x, y) { return y.maxSum - x.maxSum; })).slice(0, 9);
            // program will crash if without setTimeout
            setTimeout(function () {
                if (_this.enableProcareBundlePushout && _this.procareBundlePushoutChecked) {
                    _this.setSelectedSchedule(result[0]);
                }
                else {
                    _this.setSelectedSchedule(null);
                }
            });
            sessionStorage.setItem(SessionKey.SliceScheduleListAllSumZero, "" + result.every(function (item) { return item.maxSum === 0; }));
            result.forEach(function (item, index) {
                item._rank = index + 1;
            });
            return result;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AutoSchedule.prototype, "showNoAffiliatesCheck", {
        get: function () {
            if (this.parent.priority !== PredefinePriority.NextAvailableService) {
                return false;
            }
            if (this.sliceScheduleList.every(function (x) { return x.technicianId === '0'; })) {
                return false;
            }
            var top2DayWithTimeAsc = this.showScheduleList.slice(0, 6);
            // cp-1294
            if (top2DayWithTimeAsc.length >= 2) {
                var firstDay = top2DayWithTimeAsc[0], secondDay = top2DayWithTimeAsc[1];
                var isSameDay = moment(firstDay.schedulestarttime).format('MM/DD/YYYY') ===
                    moment(secondDay.schedulestarttime).format('MM/DD/YYYY');
                if (!isSameDay) {
                    top2DayWithTimeAsc = this.showScheduleList.slice(0, 2);
                }
            }
            var top9 = this.sliceScheduleList.filter(function (x) { return x.maxSum > 0; });
            var intersection = intersectionBy(top2DayWithTimeAsc, top9, function (item) { return item.schedulestarttime; });
            console.log('intersection', toJS(intersection));
            return intersection.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    AutoSchedule.prototype.bundlePriority = function () {
        if (this.parent.isLastVersionAutoSchedule) {
            return null;
        }
        return this.parent.isAutoSchedule && this.parent.serviceCodeId && this.parent.priority;
    };
    AutoSchedule.prototype.init = function () {
        var _this = this;
        reaction(function () {
            return { priority: _this.bundlePriority(),
                isLastVersionAutoSchedule: _this.parent.isLastVersionAutoSchedule };
        }, function (result) {
            if (result.priority) {
                _this.proCareSupportBundleTypeReactionHander.executeWithoutEffect(function () {
                    return _this.setProCareSupportBundleType(_this.proCareSupportBundleTypeOrigin);
                });
            }
        });
        this.proCareSupportBundleTypeReactionHander = generatorReactionHandler(function () { return _this.proCareSupportBundleType; }, function () { return _this.bundlePriority(); });
    };
    AutoSchedule.prototype.setProCareSupportBundleType = function (type) {
        this.proCareSupportBundleType = type;
    };
    AutoSchedule.prototype.setScheduleLoading = function (loading) {
        this.scheduleLoading = loading;
    };
    AutoSchedule.prototype.setProcareBundlePushoutChecked = function (checked) {
        this.procareBundlePushoutChecked = checked;
    };
    AutoSchedule.prototype.setSelectedSchedule = function (schdule) {
        this.selectedSchedule = schdule;
    };
    AutoSchedule.prototype.toggleNoAvailableChecked = function () {
        this.noAvailableChecked = !this.noAvailableChecked;
    };
    AutoSchedule.prototype.getProCareSupportBundleType = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getProCareSupportBundleType()];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.proCareSupportBundleType = data;
                            _this.proCareSupportBundleTypeOrigin = data;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    AutoSchedule.prototype.getWeatherForecastByTime = function (dates) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.api().getWeatherForecastByTime(dates)];
                    case 1:
                        data = _a.sent();
                        runInAction(function () {
                            _this.weather = data;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    AutoSchedule.prototype.saveToSession = function () {
        var _this = this;
        if (!this.selectedSchedule)
            return;
        var autoScheduleModel = new ScheduleResult();
        this.autoScheduleModel = autoScheduleModel;
        [
            'schedulestarttime',
            'scheduleendtime',
            'technicianId',
            'sum',
            'woSort',
            'workTime',
            'affiliateId',
            'projectId',
            'bundleWoIds',
            '_rank'
        ].forEach(function (key) {
            autoScheduleModel[key] = _this.selectedSchedule[key];
        });
        autoScheduleModel.scheduleV32 = [
            {
                technicianIds: this.selectedSchedule.technicianId,
                scheduleStartTime: this.selectedSchedule.schedulestarttime,
                scheduleEndTime: this.selectedSchedule.scheduleendtime,
                scores: this.selectedSchedule.sum
            }
        ];
        autoScheduleModel.bundleDataDirection = this.getBundleDataDirection();
        sessionStorage.setItem(SessionKey.AutoScheduleModel, autoScheduleModel.toString());
        sessionStorage.setItem(SessionKey.SelectedSchedule, JSON.stringify(this.selectedSchedule));
    };
    AutoSchedule.prototype.loadFromSession = function () {
        var value = sessionStorage.getItem(SessionKey.AutoScheduleModel);
        this.autoScheduleModel = value ? ScheduleResult.toJSON(value) : null;
    };
    AutoSchedule.prototype.cleanSession = function () {
        sessionStorage.removeItem(SessionKey.AutoScheduleModel);
        sessionStorage.removeItem(SessionKey.SliceScheduleListAllSumZero);
        sessionStorage.removeItem(SessionKey.SelectedSchedule);
    };
    AutoSchedule.prototype.cleanData = function () {
        this.autoScheduleModel = null;
        this.selectedSchedule = null;
    };
    AutoSchedule.prototype.getBundleDataDirection = function () {
        if (this.proCareSupportBundleType === ProCareSupportBundleType.PullIn) {
            return BundleDataDirection.Pull;
        }
        if (this.proCareSupportBundleType === ProCareSupportBundleType.PushOut) {
            return this.procareBundlePushoutChecked && this.enableProcareBundlePushout
                ? BundleDataDirection.Push
                : BundleDataDirection.Normal;
        }
        if (this.proCareSupportBundleType === ProCareSupportBundleType.PullInOrPushOut) {
            return this.procareBundlePushoutChecked && this.enableProcareBundlePushout
                ? BundleDataDirection.Push
                : BundleDataDirection.Pull;
        }
        return BundleDataDirection.Normal;
    };
    AutoSchedule.prototype.getWeatherByTime = function (date) {
        return (this.weather.find(function (weather) { return moment.utc(weather.date).format('YYYY-MM-DD') === moment(date).format('YYYY-MM-DD'); }) || {});
    };
    AutoSchedule.prototype.caculateMaxSum = function (scheduleTimeBlocks) {
        scheduleTimeBlocks.forEach(function (schedule) { return (schedule.maxSum = Math.max.apply(null, schedule.sum.split(',').map(function (sum) { return parseFloat(sum); }))); });
    };
    AutoSchedule.prototype.api = function () {
        return {
            getProCareSupportBundleType: function () {
                return Q(http.post("RSP/NewRequest/GetProCareSupportBundleTypeByLocationId"));
            },
            getWeatherForecastByTime: function (dates) {
                return Q(http.post('RSP/NewRequest/GetWeatherForecastByTime', { times: dates }, Api.withForm));
            }
        };
    };
    __decorate([
        observable
    ], AutoSchedule.prototype, "proCareSupportBundleType", void 0);
    __decorate([
        computed
    ], AutoSchedule.prototype, "enableProcareBundle", null);
    __decorate([
        computed
    ], AutoSchedule.prototype, "enableProcareBundlePushout", null);
    __decorate([
        observable
    ], AutoSchedule.prototype, "scheduleTimeBlocks", void 0);
    __decorate([
        observable
    ], AutoSchedule.prototype, "scheduleTimeBlocksPushOut", void 0);
    __decorate([
        observable
    ], AutoSchedule.prototype, "scheduleTimeBlocksPullIn", void 0);
    __decorate([
        computed
    ], AutoSchedule.prototype, "scheduleTimeBlocksByBundleType", null);
    __decorate([
        computed
    ], AutoSchedule.prototype, "showScheduleList", null);
    __decorate([
        computed
    ], AutoSchedule.prototype, "sliceScheduleList", null);
    __decorate([
        computed
    ], AutoSchedule.prototype, "showNoAffiliatesCheck", null);
    __decorate([
        observable
    ], AutoSchedule.prototype, "weather", void 0);
    __decorate([
        observable
    ], AutoSchedule.prototype, "scheduleLoading", void 0);
    __decorate([
        observable
    ], AutoSchedule.prototype, "procareBundlePushoutChecked", void 0);
    __decorate([
        action
    ], AutoSchedule.prototype, "setProCareSupportBundleType", null);
    __decorate([
        action
    ], AutoSchedule.prototype, "setScheduleLoading", null);
    __decorate([
        action
    ], AutoSchedule.prototype, "setProcareBundlePushoutChecked", null);
    __decorate([
        observable
    ], AutoSchedule.prototype, "selectedSchedule", void 0);
    __decorate([
        action
    ], AutoSchedule.prototype, "setSelectedSchedule", null);
    __decorate([
        observable
    ], AutoSchedule.prototype, "noAvailableChecked", void 0);
    __decorate([
        action
    ], AutoSchedule.prototype, "toggleNoAvailableChecked", null);
    __decorate([
        action
    ], AutoSchedule.prototype, "getProCareSupportBundleType", null);
    __decorate([
        action
    ], AutoSchedule.prototype, "getWeatherForecastByTime", null);
    __decorate([
        action
    ], AutoSchedule.prototype, "cleanData", null);
    return AutoSchedule;
}());
export default AutoSchedule;
